import PropTypes from 'prop-types'
import React from 'react'
import {
    Dialog,
    MemberName,
} from 'react-wot-bootstrap'

import { DialogRemoveMembersPlayersTooltip } from './tooltips'
import {
    DIALOG_REMOVE_MEMBERS_TITLE,
    DIALOG_REMOVE_MEMBERS_CONTENT_1_PLAYER,
    DIALOG_REMOVE_MEMBERS_CONTENT_PLAYERS,
    DIALOG_REMOVE_MEMBERS_SUBMIT_BUTTON_CAPTION,
    DIALOG_BUTTON_CANCEL_CAPTION,
} from './translations'

import styles from './Dialogs.scss'

const propTypes = {
    selectedMembers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,

    isOpened: PropTypes.bool,

    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

const RemoveMembersDialog = (props) => {
    let dialogContent = null
    const selectedMembersCount = props.selectedMembers.length
    if (selectedMembersCount === 1) {
        const member = (<MemberName name={props.selectedMembers[0].name} />)
        dialogContent = (
            <div>
                {DIALOG_REMOVE_MEMBERS_CONTENT_1_PLAYER}
                &ensp;
                {member}
            </div>
        )
    } else if (selectedMembersCount > 0) {
        const members = props.selectedMembers.map((member) => (
            <MemberName key={member.id} name={member.name} />
        ))

        const isNeedTooltip = selectedMembersCount > 10
        const tooltip = isNeedTooltip ? (
            <DialogRemoveMembersPlayersTooltip>
                {members}
            </DialogRemoveMembersPlayersTooltip>
        ) : null

        dialogContent = (
            <div
                data-tip={isNeedTooltip}
                data-for={isNeedTooltip ? DialogRemoveMembersPlayersTooltip.id : null}
            >
                {DIALOG_REMOVE_MEMBERS_CONTENT_PLAYERS}
                &ensp;
                {isNeedTooltip ? (
                    <span className={styles.membersCount}>{selectedMembersCount}</span>
                ) : members}
                {tooltip}
            </div>
        )
    }

    return (
        <Dialog
            title={DIALOG_REMOVE_MEMBERS_TITLE}
            submitCaption={DIALOG_REMOVE_MEMBERS_SUBMIT_BUTTON_CAPTION}
            closeCaption={DIALOG_BUTTON_CANCEL_CAPTION}
            isOpened={props.isOpened}
            isFocusOnSubmitBtn
            onSubmit={props.onSubmit}
            onClose={props.onClose}
        >
            {dialogContent}
        </Dialog>
    )
}

RemoveMembersDialog.propTypes = propTypes

export default RemoveMembersDialog



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/RemoveMembers.js